// extracted by mini-css-extract-plugin
export var container = "index-module--container--2NvR0";
export var ghostClass = "index-module--ghostClass--2UGTN";
export var entryContent = "index-module--entryContent--b458E";
export var entryHeader = "index-module--entryHeader--19tiF";
export var dateClass = "index-module--dateClass--3a5UA";